import { gql } from "@apollo/client";

export const CROSS_SITE_PROMOTIONS = gql`
  query CrossSitePromotionsQuery {
    promotions {
      name
      activeSiteSideRailAd {
        name
        title
        subtitle
        image
        link
        buttonCopy
        external
        buttonAction
        experimentName
      }
      activeSiteVideoPlayerPromos {
        name
        title
        subtitle
        image
        link
        buttonCopy
        experimentName
      }
      activeSiteTopBanner {
        name
        link
        colorCSS
        content
        external
        buttonAction
      }
      activeSiteFirstLandModal {
        title
        subtitle
        image
        link
        buttonCopy
        displayType
        name
        external
        buttonAction
        experimentName
      }
      activeSitePaywallPromo {
        name
        topBannerCopy
        colorCSS
        link
        endDate
        countdownBackgroundColor
        countdownFontColor
        countdownSubFontColor
        experimentName
      }
      activeUpgradePagePromo {
        pricing {
          monthly {
            essentials
            pro
            proPlus
            platinum
          }
          annual {
            essentials
            pro
            proPlus
            platinum
          }
        }
        productIds {
          monthly {
            essentials
            pro
            proPlus
            platinum
          }
          annual {
            essentials
            pro
            proPlus
            platinum
          }
        }
        savings {
          monthly {
            essentials
            pro
            proPlus
            platinum
          }
          annual {
            essentials
            pro
            proPlus
            platinum
          }
        }
        pcntOff {
          upTo
          monthly {
            essentials
            pro
            proPlus
            platinum
          }
          annual {
            essentials
            pro
            proPlus
            platinum
          }
        }
        imageUrl
        countdownTimerOffset
        endDate
        countdownBackgroundColor
        countdownFontColor
        countdownSubFontColor
        name
        experimentName
      }
      activeClipPagePromos {
        backgroundImage
        headerCopy
        subTextCopy
        buttonCTA
        buttonURL
        buttonColor
        name
        image
        endDate
        experimentName
        buttonTextColor
        showTimer
      }
    }
  }
`;

export const IFRAME_PROMOTIONS = gql`
  query IframePromotionsQuery {
    promotions {
      name
      activeSiteVideoPlayerPromos {
        name
        experimentName
        title
        subtitle
        image
        link
        buttonCopy
      }
    }
  }
`;
